// src/pages/AdminEmpresaComprasCreate.jsx

import React, { useEffect, useState } from "react";
import {
  useParams,
  useNavigate,
  Link as RouterLink,
} from "react-router-dom";

import {
  Box,
  Typography,
  Button,
  TextField,
  MenuItem,
  Grid,
  Paper,
  Stack,
  Divider,
  Chip,
  InputAdornment,
  CircularProgress,
} from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SaveIcon from "@mui/icons-material/Save";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import PersonIcon from "@mui/icons-material/Person";
import EuroIcon from "@mui/icons-material/Euro";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PaidIcon from "@mui/icons-material/Paid";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

import { db } from "../contexts/firebase/config";

import {
  collection,
  query,
  where,
  onSnapshot,
  addDoc,
  Timestamp,
} from "firebase/firestore";

function SectionCard({ icon, title, subtitle, children }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 4,
        border: (t) => `1px solid ${t.palette.divider}`,
        bgcolor: (t) =>
          t.palette.mode === "dark"
            ? "rgba(255,255,255,0.03)"
            : "rgba(255,255,255,0.72)",
      }}
    >
      <Stack direction="row" spacing={2} alignItems="flex-start">
        <Box
          sx={{
            width: 46,
            height: 46,
            borderRadius: 3,
            display: "grid",
            placeItems: "center",
            bgcolor: "rgba(99,102,241,0.12)",
            color: "primary.main",
            flexShrink: 0,
          }}
        >
          {icon}
        </Box>

        <Box sx={{ width: "100%" }}>
          <Typography variant="h6" sx={{ fontWeight: 800 }}>
            {title}
          </Typography>

          {subtitle && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mb: 2 }}
            >
              {subtitle}
            </Typography>
          )}

          {children}
        </Box>
      </Stack>
    </Paper>
  );
}

export default function AdminEmpresaComprasCreate() {
  const { empresaId } = useParams();
  const navigate = useNavigate();

  const [clientes, setClientes] = useState([]);
  const [loadingClientes, setLoadingClientes] = useState(true);

  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState({
  clienteId: "",
  anoCompra: new Date().toISOString().split("T")[0],
  valorCompra: "",

  tipoCompra: "Novo",

  percentagemComissao: 20,
});

  useEffect(() => {
    setLoadingClientes(true);

    const qClientes = query(
      collection(db, "clientes"),
      where("empresaId", "==", empresaId)
    );

    const unsub = onSnapshot(
      qClientes,
      (snap) => {
        const arr = snap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));

        setClientes(arr);

        if (arr.length > 0) {
          setForm((prev) => ({
            ...prev,
            clienteId: prev.clienteId || arr[0].id,
          }));
        }

        setLoadingClientes(false);
      },
      () => setLoadingClientes(false)
    );

    return () => unsub();
  }, [empresaId]);

  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  async function handleSubmit(e) {
    e.preventDefault();

    if (!form.clienteId || !form.valorCompra) return;

    try {
      setSaving(true);

      const clienteObj = clientes.find(
        (c) => c.id === form.clienteId
      );

      if (!clienteObj) return;

      const valorNum = Number(form.valorCompra);

const perc =
  Number(form.percentagemComissao) / 100;

const comissao = Number(
  (
    valorNum *
    perc
  ).toFixed(2)
);

      const ano = Number(form.anoCompra);

      const dataCompra = Timestamp.fromDate(
    new Date(form.anoCompra)
);

      await addDoc(collection(db, "compras"), {
        empresaId,

        clienteId: clienteObj.id,
        clienteNome: clienteObj.nome,
        clienteEstado: clienteObj.estado,
        clientePlano: clienteObj.plano,

        valor: valorNum,

tipoCompra: form.tipoCompra,

percentagemComissao:
  Number(form.percentagemComissao),

valorComissao: comissao,

comissao,

        dataCompra,

        status: "Aberto",

        createdAt: Timestamp.now(),
      });

      navigate(`/admin/empresa/${empresaId}/compras`);
    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false);
    }
  }

  const clienteSelecionado = clientes.find(
    (c) => c.id === form.clienteId
  );

  const valorCompra = Number(form.valorCompra || 0);

const valorComissao = Number(
  (
    valorCompra *
    (Number(form.percentagemComissao) / 100)
  ).toFixed(2)
);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        p: { xs: 2, md: 4 },
        background:
          "linear-gradient(135deg, #eef2ff 0%, #f8fafc 35%, #ffffff 100%)",
      }}
    >
      <Box sx={{ maxWidth: 1500, mx: "auto" }}>
        {/* HERO */}
        <Paper
          elevation={0}
          sx={{
            mb: 3,
            overflow: "hidden",
            borderRadius: 6,
            background:
              "linear-gradient(135deg,#0f172a 0%, #14213d 55%, #312e81 100%)",
            color: "white",
            border: "1px solid rgba(255,255,255,0.08)",
            boxShadow: "0 24px 60px rgba(15,23,42,0.28)",
          }}
        >
          <Grid container>
            <Grid item xs={12} lg={9}>
              <Box sx={{ p: { xs: 3, md: 5 } }}>
                <Chip
                  icon={<ReceiptLongIcon />}
                  label="EMPRESA · COMPRAS"
                  sx={{
                    mb: 2,
                    bgcolor: "rgba(255,255,255,0.08)",
                    color: "white",
                    fontWeight: 700,
                  }}
                />

                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: 900,
                    lineHeight: 1,
                    mb: 2,
                    letterSpacing: "-0.04em",
                    fontSize: {
                      xs: "2.6rem",
                      md: "4rem",
                    },
                  }}
                >
                  Registar nova compra
                </Typography>

                <Typography
                  variant="h6"
                  sx={{
                    color: "rgba(255,255,255,0.72)",
                    maxWidth: 700,
                    lineHeight: 1.7,
                    fontWeight: 400,
                  }}
                >
                  Associa uma compra a um cliente e calcula automaticamente
                  a comissão do parceiro.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} lg={3}>
              <Box
                sx={{
                  p: 4,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  component={RouterLink}
                  to={`/admin/empresa/${empresaId}/compras`}
                  startIcon={<ArrowBackIcon />}
                  variant="outlined"
                  fullWidth
                  sx={{
                    borderRadius: 999,
                    color: "white",
                    borderColor: "rgba(255,255,255,0.2)",
                    backdropFilter: "blur(10px)",
                    bgcolor: "rgba(255,255,255,0.06)",
                    "&:hover": {
                      borderColor: "rgba(255,255,255,0.3)",
                      bgcolor: "rgba(255,255,255,0.10)",
                    },
                  }}
                >
                  Voltar
                </Button>

                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    borderRadius: 4,
                    bgcolor: "rgba(255,255,255,0.75)",
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <Typography
    variant="caption"
    sx={{
        display: "block",
        color: "text.secondary",
        fontWeight: 700,
    }}
>
    Comissão prevista
</Typography>

<Typography
    variant="h3"
    sx={{
        fontWeight: 900,
        color: "#111827",
        lineHeight: 1,
        mt: 1,
    }}
>
    {form.percentagemComissao}%
</Typography>

<Typography
    variant="body2"
    sx={{
        mt: 1,
        color: "text.secondary",
        fontWeight: 600,
    }}
>
    Percentagem aplicada
</Typography>

<Divider sx={{ my: 2 }} />

<Typography
    variant="caption"
    sx={{
        display: "block",
        color: "text.secondary",
        fontWeight: 700,
    }}
>
    Valor da Comissão
</Typography>

<Typography
    variant="h4"
    sx={{
        fontWeight: 900,
        color: "success.main",
        mt: 1,
    }}
>
    € {valorComissao.toFixed(2)}
</Typography>
                </Paper>
              </Box>
            </Grid>
          </Grid>
        </Paper>

        {/* FORM */}
        <Grid container spacing={3}>
          {/* LEFT */}
          <Grid item xs={12} lg={5}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 5,
                height: "100%",
                border: (t) => `1px solid ${t.palette.divider}`,
                bgcolor: "rgba(255,255,255,0.72)",
                backdropFilter: "blur(14px)",
              }}
            >
              <Box
                sx={{
                  width: 50,
                  height: 50,
                  borderRadius: 4,
                  display: "grid",
                  placeItems: "center",
                  bgcolor: "rgba(99,102,241,0.12)",
                  color: "primary.main",
                  mb: 3,
                }}
              >
                <ShoppingCartCheckoutIcon />
              </Box>

              <Typography variant="h4" sx={{ fontWeight: 900, mb: 1 }}>
                Nova compra
              </Typography>

              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ mb: 3 }}
              >
                O tipo da compra define automaticamente a percentagem inicial da comissão, podendo ser alterada antes de guardar.
              </Typography>

              <Divider sx={{ mb: 3 }} />

              <Stack spacing={2}>
                <Chip
                  icon={<PaidIcon />}
                  label="Novo = 20%"
                  color="success"
                  sx={{
                    width: "fit-content",
                    fontWeight: 700,
                  }}
                />

                <Chip
                  icon={<CalendarMonthIcon />}
                  label="Renovação = 2%"
                  color="warning"
                  sx={{
                    width: "fit-content",
                    fontWeight: 700,
                  }}
                />

                <Chip
                  icon={<ReceiptLongIcon />}
                  label="Pagamento inicial: Aberto"
                  sx={{
                    width: "fit-content",
                    fontWeight: 700,
                  }}
                />
              </Stack>
            </Paper>
          </Grid>

          {/* RIGHT */}
          <Grid item xs={12} lg={7}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 5,
                border: (t) => `1px solid ${t.palette.divider}`,
                bgcolor: "rgba(255,255,255,0.72)",
                backdropFilter: "blur(14px)",
              }}
            >
              <Box component="form" onSubmit={handleSubmit}>
                <Stack spacing={3}>
                  <SectionCard
                    icon={<PersonIcon />}
                    title="Cliente"
                    subtitle="Seleciona o cliente associado à compra."
                  >
                    {loadingClientes ? (
                      <Box sx={{ py: 2 }}>
                        <CircularProgress />
                      </Box>
                    ) : (
                      <TextField
                        select
                        label="Cliente"
                        fullWidth
                        value={form.clienteId}
                        onChange={(e) =>
                          handleChange("clienteId", e.target.value)
                        }
                      >
                        {clientes.map((c) => (
                          <MenuItem key={c.id} value={c.id}>
                            {c.nome} ({c.plano} / {c.estado})
                          </MenuItem>
                        ))}
                      </TextField>
                    )}
                  </SectionCard>

                  <SectionCard
    icon={<EuroIcon />}
    title="Detalhes da compra"
    subtitle="Ano, valor, tipo de compra e comissão."
>
    <Grid container spacing={2}>

        <Grid item xs={12} md={6}>
            <TextField
    label="Data da Compra"
    type="date"
    fullWidth
    value={form.anoCompra}
    onChange={(e) =>
        handleChange("anoCompra", e.target.value)
    }
    InputLabelProps={{
        shrink: true,
    }}
/>
        </Grid>

        <Grid item xs={12} md={6}>
            <TextField
                label="Valor da Compra (€)"
                type="number"
                fullWidth
                value={form.valorCompra}
                onChange={(e) =>
                    handleChange("valorCompra", e.target.value)
                }
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            €
                        </InputAdornment>
                    ),
                }}
            />
        </Grid>

    <Grid item xs={12} md={6}>
    <TextField
        label="Comissão (%)"
        type="number"
        fullWidth
        value={form.percentagemComissao}
        onChange={(e) =>
            handleChange(
                "percentagemComissao",
                e.target.value
            )
        }
        InputProps={{
            endAdornment: (
                <InputAdornment position="end">
                    %
                </InputAdornment>
            ),
        }}
    />
</Grid>

<Grid item xs={12} md={6}>
    <TextField
        label="Valor da Comissão (€)"
        fullWidth
        disabled
        value={valorComissao.toFixed(2)}
        InputProps={{
            startAdornment: (
                <InputAdornment position="start">
                    €
                </InputAdornment>
            ),
        }}
    />
</Grid>

<Grid item xs={12}>

    <Typography
        variant="subtitle2"
        sx={{
            mt: 1,
            mb: 2,
            fontWeight: 800,
        }}
    >
        Tipo da Compra
    </Typography>

    <Grid container spacing={2}>

        <Grid item xs={12} md={6}>

            <Paper
                elevation={0}
                onClick={() => {
                    handleChange("tipoCompra", "Novo");
                    handleChange("percentagemComissao", 20);
                }}
                sx={{
                    p: 2,
                    cursor: "pointer",
                    borderRadius: 3,
                    border:
                        form.tipoCompra === "Novo"
                            ? "2px solid #22C55E"
                            : "1px solid #E5E7EB",
                    bgcolor:
                        form.tipoCompra === "Novo"
                            ? "#F0FDF4"
                            : "#FFFFFF",
                    transition: ".2s",
                    "&:hover": {
                        transform: "translateY(-2px)",
                    },
                }}
            >

                <Typography
                    variant="h6"
                    fontWeight={800}
                >
                    🟢 Novo
                </Typography>

                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: .5 }}
                >
                    Compra inicial
                </Typography>

            </Paper>

        </Grid>

        <Grid item xs={12} md={6}>

            <Paper
                elevation={0}
                onClick={() => {
                    handleChange("tipoCompra", "Renovado");
                    handleChange("percentagemComissao", 2);
                }}
                sx={{
                    p: 2,
                    cursor: "pointer",
                    borderRadius: 3,
                    border:
                        form.tipoCompra === "Renovado"
                            ? "2px solid #F59E0B"
                            : "1px solid #E5E7EB",
                    bgcolor:
                        form.tipoCompra === "Renovado"
                            ? "#FFF7ED"
                            : "#FFFFFF",
                    transition: ".2s",
                    "&:hover": {
                        transform: "translateY(-2px)",
                    },
                }}
            >

                <Typography
                    variant="h6"
                    fontWeight={800}
                >
                    🟠 Renovado
                </Typography>

                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: .5 }}
                >
                    Renovação anual
                </Typography>

            </Paper>

        </Grid>

    </Grid>

</Grid>

    </Grid>
</SectionCard>

                  <Divider />

                  <Stack
                    direction="row"
                    justifyContent="flex-end"
                    spacing={2}
                  >
                    <Button
                      component={RouterLink}
                      to={`/admin/empresa/${empresaId}/compras`}
                      sx={{
                        borderRadius: 999,
                        fontWeight: 700,
                        textTransform: "none",
                      }}
                    >
                      Cancelar
                    </Button>

                    <Button
                      type="submit"
                      variant="contained"
                      disabled={saving}
                      startIcon={<SaveIcon />}
                      sx={{
                        borderRadius: 999,
                        px: 3,
                        py: 1.2,
                        fontWeight: 800,
                        textTransform: "none",
                        boxShadow:
                          "0 12px 30px rgba(99,102,241,0.35)",
                      }}
                    >
                      {saving ? "A guardar..." : "Salvar Compra"}
                    </Button>
                  </Stack>
                </Stack>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}